export const appConstants = {
    // --------For Development------------
    // baseURL: 'http://192.168.5.106:5000/api/',
    // socketUrl: 'http://192.168.5.106:5000/',
    // loginURL: 'http://192.168.5.106:3000/login',
    // frontendURL: 'http://192.168.5.106:3000/',
    // loginPath: "/login",


    // --------For Production Server With Edios Atlas Mongodb------------

    baseURL: 'https://app.invoicenrecover.au/api/',
    socketUrl: 'https://app.invoicenrecover.au/',
    frontBaseURL: 'https://app.invoicenrecover.au/',
    loginURL: 'https://app.invoicenrecover.au/login',
    loginPath: '/login',

    // --------For Edios Test Server With Edios Atlas Mongodb------------

    // baseURL: 'http://202.164.43.205:8083/api/',
    // socketUrl: 'http://202.164.43.205:8083/', 
    // frontBaseURL: 'http://202.164.43.205:8083/',
    // loginURL: 'http://202.164.43.205:8083/login',
    // loginPath: '/login',

    // ----------Common-------------
    googleAutoCommpleteKey: "AIzaSyCNe-x9Jn_2903j9PxhLPw6SPGXMwIlkCM",
    privateKey: "PfngA5S5H5",
    maxRecordsFetchCount: 10,
    SIGNATURE_KEY: "RA169",
    version: 1.0,
    userStatus: "Pending",
    page: 1,
    limit: 20
};